export default __webpack_public_path__ + "static/media/jldicon.3e1353cf.webp";